import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function HeroSection() {
  useEffect(() => {
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.body.appendChild(script1);
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/embed/zxi7msooo7.js';
    script2.async = true;
    script2.type = 'module';
    document.body.appendChild(script2);
    return () => {
      if (document.body.contains(script1)) {
        document.body.removeChild(script1);
      }
      if (document.body.contains(script2)) {
        document.body.removeChild(script2);
      }
    };
  }, []);
  return <section className="relative pt-24 pb-12 md:pt-32 lg:pt-40 md:pb-16 lg:pb-24 overflow-hidden bg-gradient-to-b from-slate-50 to-white" data-id="element-308">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-309">
        <div className="text-center mb-8 md:mb-12" data-id="element-310">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-5xl lg:text-6xl font-bold text-slate-900 tracking-tight mb-4 md:mb-6 px-2" data-id="element-311">
            Activa HeyLloyd y deja que la IA te guíe{' '}
            <span className="text-cyan-500" data-id="element-312">directamente en tu pantalla</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-base md:text-lg lg:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed px-2" data-id="element-313">
            En esta página aprenderás cómo acceder a HeyLloyd, cómo usarlo y
            cómo descargar los Lloyds personalizados que hemos creado para ti.
            Sigue los pasos en orden y tendrás la IA trabajando contigo en menos
            de unos minutos.
          </motion.p>
        </div>

        {/* Video Container */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="relative max-w-4xl mx-auto" data-id="element-314">
          {/* Video wrapper with border glow effect */}
          <div className="relative bg-slate-900 shadow-2xl overflow-hidden" style={{
          boxShadow: '0 0 0 1px rgba(6, 182, 212, 0.3), 0 0 20px rgba(6, 182, 212, 0.4), 0 0 40px rgba(6, 182, 212, 0.3), 0 0 60px rgba(6, 182, 212, 0.2)'
        }} data-id="element-315">
            <style dangerouslySetInnerHTML={{
            __html: `
                wistia-player[media-id='zxi7msooo7']:not(:defined) { 
                  background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/zxi7msooo7/swatch'); 
                  display: block; 
                  filter: blur(5px); 
                  padding-top: 56.25%; 
                }
              `
          }} data-id="element-316" />
            <wistia-player media-id="zxi7msooo7" aspect="1.7777777777777777" className="w-full h-full" data-id="element-317" />
          </div>

          {/* Video Context */}
          <div className="mt-6 md:mt-8 bg-slate-50 rounded-lg md:rounded-xl p-4 md:p-6 border border-slate-200" data-id="element-318">
            <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base" data-id="element-319">
              En el video verás:
            </h3>
            <ul className="grid md:grid-cols-3 gap-3 md:gap-4 text-xs md:text-sm text-slate-600" data-id="element-320">
              <li className="flex items-start" data-id="element-321">
                <span className="w-1.5 h-1.5 bg-cyan-500 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-322" />
                Dónde descargar / abrir HeyLloyd en tu Mac.
              </li>
              <li className="flex items-start" data-id="element-323">
                <span className="w-1.5 h-1.5 bg-cyan-500 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-324" />
                Cómo se ve la superposición (overlay) en tu pantalla.
              </li>
              <li className="flex items-start" data-id="element-325">
                <span className="w-1.5 h-1.5 bg-cyan-500 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-326" />
                Cómo cargar y usar los Lloyds personalizados.
              </li>
            </ul>
            <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-slate-200 text-center" data-id="element-327">
              <p className="text-slate-900 font-medium flex flex-col md:flex-row items-center justify-center text-xs md:text-sm gap-1 md:gap-0" data-id="element-328">
                <span data-id="element-329">
                  Cuando termines el video, baja en esta página y sigue los
                  pasos 1, 2 y 3.
                </span>
                <ArrowDown className="w-4 h-4 md:ml-2 animate-bounce text-cyan-500" data-id="element-330" />
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}